import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 4FA696A5-8843-4E3F-B9BF-5BCF5B6C4D2C
 * name format-font-size-decrease
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-font-size-decrease.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatFontSizeDecreaseIcon = createSvgIcon(<><path d="M5.12,14L7.5,7.67L9.87,14M6.5,5L1,19H3.25L4.37,16H10.62L11.75,19H14L8.5,5H6.5M18,17L23,11.93L21.59,10.5L19,13.1V7H17V13.1L14.41,10.5L13,11.93L18,17Z" /></>, 'FormatFontSizeDecreaseIcon');
export default FormatFontSizeDecreaseIcon